import React, { ReactNode } from "react";
import tw from "~/common/concat";
import Icon from "~/common/Icons/Standard";

interface Props {
  children?: ReactNode;
  title?: string;
  showClose?: boolean;
}

const PopoverTemplate = ({
  children,
  title = "",
  showClose = false,
}: Props) => (
  <div className="popover" role="tooltip">
    <div className="arrow" />
    <div data-target="popover">
      <h3 className="popover-title">
        {title}
        {showClose && (
          <button
            type="button"
            className="close opacity-100"
            aria-label="close"
          >
            <Icon
              name="remix-close"
              className={tw(
                "h-5",
                "fill-current",
                "text-gray-800",
                "w-5",
                "pointer-events-none",
              )}
            />
          </button>
        )}
      </h3>
      <div className="popover-content">{children}</div>
    </div>
  </div>
);

export default PopoverTemplate;
